import { connect } from 'react-redux';

import ReviewModalContent from '../components/modals/ReviewModalContent';

const _mapStateToProps = ({ currentApp }) => ({
    appName: (currentApp && currentApp.name) || '',
});

export default connect(_mapStateToProps)(ReviewModalContent);
